import { Z_INDEX } from "@/style/zIndex";
import { css } from "@emotion/react";

import { Portal } from "@/component/common/Portal";

type FullModalProps = {
  children: React.ReactNode;
};

export function FullModal({ children }: FullModalProps) {
  return (
    <Portal id="modal-root">
      <div
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: ${Z_INDEX.overlay};
        `}
      >
        <div
          css={css`
            height: 100dvh;
            width: 48rem;
            overflow-y: auto;
            --parent-bg-color: #fff;
            background-color: var(--parent-bg-color);
          `}
        >
          {children}
        </div>
      </div>
    </Portal>
  );
}
